module.exports = __webpack_public_path__ + "images/_/programs/zeroHeroes/images/characters/apprenticesRowArmsFolded-8d1e0374293625adce385ef4a156323c.png";


//////////////////
// WEBPACK FOOTER
// ./programs/zeroHeroes/images/characters/apprenticesRowArmsFolded.png
// module id = 2486
// module chunks = 2